import * as CONST from '../ActionTypes';

const initialState = {
  authLoading: true,
  isLoggedIn: false,
  errorMessage: '',
  // ログインユーザーの情報
  id: null,
  email: '',
  name: '',
  accessToken: '',
  refreshToken: '',
  paymentAgency: '',
  companyId: null,
  company: null,
  // option権限
  isAbledCsv: false,
  isAbledQr: false,
  isAbledTransactionAnalytics: false,
  isAbledBroadcastMail: false,
  isAbledSalesPersonList: false,
  isAbledSalesPersonCreate: false,
  isAbledProductCreate: false,
  isAbledCoupon: false,
  isAbledYamatoCsv: false,
  isAbledReceipt: false,
  isAbledInvoice: false,
  isAbledAccountTransfer: false,
  isAbledApi: false,
  isAbledLink: false,
  // 口座情報
  accountName: '',
  accountNumber: '',
  accountType: null,
  bankBranch: '',
  bankName: '',
  // パスワード更新用
  isSuccess: false,
  isFailure: false,
  updateErrorMessage: '',
  companyCustomerField: null,
  purchaseLimitPerDate: null,
  isAbledInvoiceSystem: null,
  invoiceRegistrationNumber: null,
  taxInputType: null,
};

function auth(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // ログイン
    // -----------------
    case CONST.LOGIN_SUCCESS:
      return Object.assign({}, state, {
        isLoggedIn: true,
        errorMessage: '',
        id: action.payload.employee.id,
        email: action.payload.employee.email,
        name: action.payload.employee.name,
        paymentAgency: action.payload.payment_agency,
        companyId: action.payload.company.id,
        isAbledCsv: action.payload.company.is_abled_csv,
        isAbledTransactionCsv: action.payload.company.is_abled_transaction_csv,
        isAbledQr: action.payload.company.is_abled_qr,
        isAbledTransactionAnalytics: action.payload.company.is_abled_transaction_analytics,
        isAbledBroadcastMail: action.payload.company.is_abled_broadcast_mail,
        isAbledSalesPersonList: action.payload.company.is_abled_sales_person_list,
        isAbledSalesPersonCreate: action.payload.company.is_abled_sales_person_create,
        isAbledProductCreate: action.payload.company.is_abled_product_create,
        isAbledCoupon: action.payload.company.is_abled_coupon,
        isAbledYamatoCsv: action.payload.company.is_abled_yamato_csv,
        isAbledReceipt: action.payload.company.is_abled_receipt,
        isAbledInvoice: action.payload.company.is_abled_invoice,
        isAbledAccountTransfer: action.payload.company.is_abled_account_transfer,
        isAbledApi: action.payload.company.is_abled_api,
        isAbledLink: action.payload.company.is_abled_link,
        accountName: action.payload.company?.account_name || '',
        accountNumber: action.payload.company?.account_number || '',
        accountType: action.payload.company?.account_type || null,
        bankBranch: action.payload.company?.bank_branch || '',
        bankName: action.payload.company?.bank_name || '',
        accessToken: action.payload.access_token,
        refreshToken: action.payload.refresh_token,
        company: action.payload.company,
        companyCustomerField: action.payload.company.company_customer_field,
        purchaseLimitPerDate: action.payload.company.purchase_limit_per_date,
        isAbledInvoiceSystem: action.payload.company.is_abled_invoice_system,
        invoiceRegistrationNumber: action.payload.company.invoice_registration_number,
        taxInputType: action.payload.company.tax_input_type,
      });
    case CONST.LOGIN_FAILURE:
      return Object.assign({}, state, {
        isLoggedIn: false,
        errorMessage: 'Eメールかパスワードが正しくありません',
        id: null,
        email: '',
        name: '',
        paymentAgency: '',
        companyId: null,
        isAbledCsv: false,
        isAbledTransactionCsv: false,
        isAbledQr: false,
        isAbledTransactionAnalytics: false,
        isAbledBroadcastMail: false,
        isAbledSalesPersonList: false,
        isAbledSalesPersonCreate: false,
        isAbledProductCreate: false,
        isAbledCoupon: false,
        isAbledYamatoCsv: false,
        isAbledReceipt: false,
        isAbledInvoice: false,
        isAbledAccountTransfer: false,
        isAbledApi: false,
        isAbledLink: false,
        accountName: '',
        accountNumber: '',
        accountType: null,
        bankBranch: '',
        bankName: '',
        accessToken: '',
        refreshToken: '',
        company: null,
        companyCustomerField: null,
        purchaseLimitPerDate: null,
        isAbledInvoiceSystem: null,
        invoiceRegistrationNumber: null,
        taxInputType: null,
      });
    // -----------------
    // リフレッシュトークンでログイン
    // -----------------
    case CONST.REFRESH_TOKEN_LOGIN_SUCCESS:
      return Object.assign({}, state, {
        isLoggedIn: true,
        errorMessage: '',
        id: action.payload.employee.id,
        email: action.payload.employee.email,
        name: action.payload.employee.name,
        paymentAgency: action.payload.payment_agency,
        companyId: action.payload.company.id,
        isAbledCsv: action.payload.company.is_abled_csv,
        isAbledTransactionCsv: action.payload.company.is_abled_transaction_csv,
        isAbledQr: action.payload.company.is_abled_qr,
        isAbledTransactionAnalytics: action.payload.company.is_abled_transaction_analytics,
        isAbledBroadcastMail: action.payload.company.is_abled_broadcast_mail,
        isAbledSalesPersonList: action.payload.company.is_abled_sales_person_list,
        isAbledSalesPersonCreate: action.payload.company.is_abled_sales_person_create,
        isAbledProductCreate: action.payload.company.is_abled_product_create,
        isAbledCoupon: action.payload.company.is_abled_coupon,
        isAbledYamatoCsv: action.payload.company.is_abled_yamato_csv,
        isAbledReceipt: action.payload.company.is_abled_receipt,
        isAbledInvoice: action.payload.company.is_abled_invoice,
        isAbledAccountTransfer: action.payload.company.is_abled_account_transfer,
        isAbledApi: action.payload.company.is_abled_api,
        isAbledLink: action.payload.company.is_abled_link,
        accountName: action.payload.company?.account_name || '',
        accountNumber: action.payload.company?.account_number || '',
        accountType: action.payload.company?.account_type || null,
        bankBranch: action.payload.company?.bank_branch || '',
        bankName: action.payload.company?.bank_name || '',
        accessToken: action.payload.access_token,
        refreshToken: action.payload.refresh_token,
        authLoading: false,
        company: action.payload.company,
        companyCustomerField: action.payload.company.company_customer_field,
        purchaseLimitPerDate: action.payload.company.purchase_limit_per_date,
        isAbledInvoiceSystem: action.payload.company.is_abled_invoice_system,
        invoiceRegistrationNumber: action.payload.company.invoice_registration_number,
        taxInputType: action.payload.company.tax_input_type,
      });
    case CONST.REFRESH_TOKEN_LOGIN_FAILURE:
      return Object.assign({}, state, {
        isLoggedIn: false,
        errorMessage: '',
        id: null,
        email: '',
        name: '',
        paymentAgency: '',
        companyId: null,
        isAbledCsv: false,
        isAbledTransactionCsv: false,
        isAbledQr: false,
        isAbledTransactionAnalytics: false,
        isAbledBroadcastMail: false,
        isAbledSalesPersonList: false,
        isAbledSalesPersonCreate: false,
        isAbledProductCreate: false,
        isAbledCoupon: false,
        isAbledYamatoCsv: false,
        isAbledReceipt: false,
        isAbledInvoice: false,
        isAbledAccountTransfer: false,
        isAbledApi: false,
        isAbledLink: false,
        accountName: '',
        accountNumber: '',
        accountType: null,
        bankBranch: '',
        bankName: '',
        accessToken: '',
        refreshToken: '',
        authLoading: false,
        company: null,
        companyCustomerField: null,
        purchaseLimitPerDate: null,
        isAbledInvoiceSystem: null,
        invoiceRegistrationNumber: null,
        taxInputType: null,
      });
    // -----------------
    // パスワード更新
    // -----------------
    case CONST.UPDATE_PASSWORD_SUCCESS:
      return Object.assign({}, state, {
        isSuccess: true,
        isFailure: false,
        errorMessage: '',
      });
    case CONST.UPDATE_PASSWORD_FAILURE:
      return Object.assign({}, state, {
        isSuccess: false,
        isFailure: true,
        updateErrorMessage: action.payload,
      });
    // Settings
    case CONST.UPDATE_SETTINGS_SUCCESS:
      return Object.assign({}, state, {
        isSuccess: true,
        isFailure: false,
        errorMessage: '',
      });
    case CONST.UPDATE_SETTINGS_FAILURE:
      return Object.assign({}, state, {
        isSuccess: false,
        isFailure: true,
        updateErrorMessage: action.payload,
      });
    case CONST.UPDATE_SETTING_EMAIL_SUCCESS:
      return Object.assign({}, state, {
        isSuccess: true,
        isFailure: false,
        errorMessage: '',
      });
    case CONST.UPDATE_SETTING_EMAIL_FAILURE:
      return Object.assign({}, state, {
        isSuccess: false,
        isFailure: true,
        updateErrorMessage: action.payload,
      });
    // setting send mail
    // -----------------
    // 結果フラグクリア
    // -----------------
    case CONST.CLEAR_UPDATE_PASSWORD_RESULT_FLG:
      return Object.assign({}, state, {
        isSuccess: false,
        isFailure: false,
        updateErrorMessage: '',
      });
    case CONST.UPDATE_LOGO_SEAL_SUCCESS:
      return Object.assign({}, state, {
        isSuccess: true,
        isFailure: false,
        updateErrorMessage: '',
        company: {
          ...state.company,
          company_logo_image: action.payload.company_logo_image,
          company_seal_image: action.payload.company_seal_image,
        },
      });
    case CONST.UPDATE_LOGO_SEAL_FAILURE:
      return Object.assign({}, state, {
        isSuccess: false,
        isFailure: true,
        updateErrorMessage: action.payload,
      });
    // -----------------
    // ログアウト
    // -----------------
    case CONST.LOGOUT:
      return Object.assign({}, state, {
        authLoading: false,
        isLoggedIn: false,
        errorMessage: '',
        id: null,
        email: '',
        name: '',
        paymentAgency: '',
        companyId: null,
        isAbledCsv: false,
        isAbledTransactionCsv: false,
        isAbledQr: false,
        isAbledTransactionAnalytics: false,
        isAbledBroadcastMail: false,
        isAbledSalesPersonList: false,
        isAbledSalesPersonCreate: false,
        isAbledProductCreate: false,
        isAbledCoupon: false,
        isAbledYamatoCsv: false,
        isAbledReceipt: false,
        isAbledInvoice: false,
        isAbledAccountTransfer: false,
        isAbledApi: false,
        isAbledLink: false,
        accountName: '',
        accountNumber: '',
        accountType: null,
        bankBranch: '',
        bankName: '',
        accessToken: '',
        refreshToken: '',
        companyCustomerField: null,
        purchaseLimitPerDate: null,
        isAbledInvoiceSystem: null,
        invoiceRegistrationNumber: null,
        taxInputType: null,
      });
    default:
      return state;
  }
}

export default auth;
